import { Helmet } from "react-helmet"

function Donacije() {
    return (
        <div className="flex-container full-width flex-grow-1">
          <Helmet>
              <title>Historiografija.ba | Donacije</title>
              <meta
                  name="description"
                  content="Donacije"
                  data-react-helmet="true" 
              />
          </Helmet>
          <div className="full-width padding-2p static-page-container">
                <h1 className="font-weight-500 text-center">Donacije</h1>
                <p>
                  Mi smo nezavisni portal koji uspostavlja veze između svjetske i historiografije u Bosni i Hercegovini.
Nemamo nikakve stalne sponzore i nikakve prikrivene namjere. Nismo populistički usmjereni, ne
objavljujemo trivijalne nego pažljivo pripremljene i pouzdane sadržaje. Uticaj našeg portala stalno
raste, ali, nećemo se moći dalje razvijati bez Vaše podrške. Podržavajući naš rad donacijama pomažete
nam da ostanemo profesionalni. Ako nas želite podržati to možete učiniti uplatom donacije na naš
bankovni račun:
                </p>
                <p>
                  Za uplate iz BiH: Raiffeisen bank<br />
Broj racuna: 1610000107430033<br />
Primalac: Udruženje za modernu istoriju:<br />
Svrha uplate: Donacija za portal historiografija.ba
                </p>
                <p>
                  Za Uplate iz inozemstva:<br />
BENEFICIARY BANK: Raiffeissen Bank DD Bosna i Hercegovina<br />
SWEIFT CODE: RZBABA2S<br />
IBAN CODE: BA391610000107430033<br />
FULL BENEFICIARY NAME: Udruzenje za modernu historiju<br />
BENEFICIARY ADDRESS: Alipasina 9, Sarajevo, BiH
                </p>
          </div>
        </div>
    )
}

export default Donacije